export enum Role {
    ADMIN = 'ROLE_ADMIN',
    MANAGER = 'ROLE_MANAGER',
    SUPER_USER = 'ROLE_SUPER_USER',
    TESTER = 'ROLE_TESTER',
    MODERATOR = 'ROLE_MODERATOR'
}
